import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment-timezone";
import socket from "../../socket/socket";

const OrderDispatchLog = ({ id, showLog }) => {
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const token = localStorage.getItem("token");
  const fetchOrderLog = async () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}order/debug/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setLogs(res.data.data);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (showLog === true) {
      fetchOrderLog();
    }
  }, [id, showLog]);
  useEffect(() => {
    socket.on(`admin:ordersUpdate`, (data) => {
      if (data?.orderId?.trim() !== id) return;
      fetchOrderLog();
    });
    return () => {
      socket.off(`admin:ordersUpdate`);
    };
  }, []);
  return loading ? (
    <div className="spinner-border text-primary"></div>
  ) : logs?.length === 0 ? (
    <div className="text-center w-100">
      <img
        className="w-25 mx-auto py-20"
        src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
        alt="no-content"
      />
    </div>
  ) : (
    <div
      className="rounded p-4 overflow-auto text-start"
      style={{
        maxHeight: "600px",
        fontFamily: "monospace",
        fontSize: "13px",
        whiteSpace: "pre-wrap",
      }}
    >
      <pre className="m-0">
        {JSON.stringify(
          logs.map((log) => log),
          null,
          2,
        )}
      </pre>
    </div>
  );
};

export default OrderDispatchLog;
